import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="05"
            eyebrow="FAQ"
            title="关于关注，你可能还想知道"
            description="第一次接触黑料官方的读者，通常都会问下面这几个问题。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-4 md:mt-16">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <Reveal key={item.q} delay={index * 60}>
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-background-100 md:px-8"
                  >
                    <span className="flex items-start gap-4">
                      <span className="mt-0.5 font-heading text-sm font-semibold text-primary-600">
                        Q{index + 1}
                      </span>
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                    </span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-700">
                      <i className={open ? 'ri-subtract-line text-base' : 'ri-add-line text-base'}></i>
                    </span>
                  </button>
                  {open ? (
                    <div className="border-t border-background-200 px-6 py-5 md:px-8">
                      <p className="max-w-3xl pl-0 text-sm leading-relaxed text-foreground-600 md:pl-10">
                        {item.a}
                      </p>
                    </div>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}